import * as yup from 'yup'

export const validateUpdateProductCharacteristics2 = yup.object().shape({
    characteristic_id:yup
    .string()
    .min(1, 'LA CARACTERÍSTICA debe tener más de 1 caracteres'),
    characteristic_value:yup
    .string()
    .min(2, 'El VALOR DE LA CARACTERÍSTICA debe tener más de 2 caracteres'),
})